module.exports = __webpack_public_path__ + "img/06—02—Internet-Box Login.a26ad360.jpg";